import { observer } from 'mobx-react-lite'

import { AdminApp } from '@authy/lib-admin/App'

export const App = observer(() => {
    return <AdminApp />
})
